import React, { Component } from 'react';
import { translate } from 'react-i18next';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import i18n from 'i18n.js';
import {initNavbarState} from 'actions/navbar.js';
import DatabaseService from 'services/DatabaseService.js';
import UserService from 'services/UserService.js';
import Settings from './Settings.js';
import DateUtils from 'utils/DateUtils.js';
import Utils from 'utils/Utils.js';

class SettingsContainer extends Component {
    constructor(props) {
        super(props);
        this.onSignOut = this.onSignOut.bind(this);
        this.onChangeAnonymous= this.onChangeAnonymous.bind(this);
        this.onChangeWeeklyReportEnabled= this.onChangeWeeklyReportEnabled.bind(this);
        this.onChangeLanguage = this.onChangeLanguage.bind(this);
        this.onClickUnverified = this.onClickUnverified.bind(this);
        this.onClickChangePassword= this.onClickChangePassword.bind(this);
        this.onClickSendVerificationEmail = this.onClickSendVerificationEmail.bind(this);
        this.onCloseVerificationModal = this.onCloseVerificationModal.bind(this);
        this.onCloseChangePasswordModal = this.onCloseChangePasswordModal.bind(this);
        this.state = {anonymous:props.userProfile.anonymous, 
                      selectedLanguage:this.getSelectedLanguage(), 
                      showVerificationModal: false, 
                      showPasswordChangeModal: false, 
                      verificationEmailState: 'unsent',
                      weeklyReportEnabled: props.userProfile.weeklyReportEnabled};
        this.onEditUser = this.onEditUser.bind(this);
        this.onEditGroup = this.onEditGroup.bind(this);

        var languageOptions = [
          { key: 'auto',   text: this.props.t('Auto-Detect Language'), value: '' },
          { key: 'en', text: 'English',  value: 'en' },
          { key: 'fr', text: 'Français', value: 'fr' },
        ];
        this.languageOptions = languageOptions;

    }

    componentWillReceiveProps(newProps) {
        var anonymous = Utils.deref(newProps, 'userProfile.anonymous');
        if(anonymous!=Utils.deref(this.props,'userProfile.anonymous')) {
            this.setState({anonymous:anonymous});
        }
        var weeklyReportEnabled = Utils.deref(newProps, 'userProfile.weeklyReportEnabled');
        if(weeklyReportEnabled!=Utils.deref(this.props,'userProfile.weeklyReportEnabled')) {
            this.setState({weeklyReportEnabled:weeklyReportEnabled});
        }
    }

    componentWillMount() {
        this.initNavBar();
    }

    initNavBar() {
        this.props.dispatch(initNavbarState({enable:true, title:this.props.t('Settings'), menuEnable:true, backButtonEnable:false, rewardsEnable:true, mode: 'main'}));
    }

    onSignOut(event){
        event.preventDefault();
        DatabaseService.signOut();
    }

    onChangeAnonymous() {
        this.setState((prevState, props)=>({anonymous:!prevState.anonymous}), ()=>{this.onToggleAnonymous()});
    }

    onChangeWeeklyReportEnabled() {
        this.setState((prevState, props)=>({weeklyReportEnabled:!prevState.weeklyReportEnabled}), ()=>{this.onToggleWeeklyReportEnabled()});
    }

    onChangeLanguage(e, {value}) {
        console.log('onChangeLanguage:', value);
        localStorage.selectedLanguage = value;
        this.setState({selectedLanguage:value});
        i18n.changeLanguage(value,()=>this.initNavBar());
        window.location.reload();
    }

    onClickUnverified() {
        this.setState({showVerificationModal:true});
    }

    onClickChangePassword() {
        this.setState({showPasswordChangeModal:true});
    }

    onClickSendVerificationEmail() {
        this.setState({verificationEmailState:'sending'});
        DatabaseService.sendAccountVerificationEmail()
            .then(()=>{
                return Utils.delay(2000); 
            })
            .then(()=>{
                this.setState({showVerificationModal:false, verificationEmailState:'unsent'});
            })
            .catch((error)=>{
                window.alert('An error occurred - check logs');
                console.error("Error:", error)
            });
    }

    onCloseVerificationModal() {
        this.setState({showVerificationModal:false});
    }

    onCloseChangePasswordModal() {
        this.setState({showPasswordChangeModal:false});
    }

    getSelectedLanguage() {
        var result = localStorage.selectedLanguage;
        console.log('Locale:', result);
        return result;
    }

    onToggleAnonymous() {
        UserService.updateProfile({
                userProfile:{
                    anonymous:this.state.anonymous,
                }
            })
            .then(()=>{})
            .catch((error)=>{console.error("Error updating profile", error)});
    }

    onToggleWeeklyReportEnabled() {
        UserService.updateProfile({
                userProfile:{
                    weeklyReportEnabled:this.state.weeklyReportEnabled,
                }
            })
            .then(()=>{})
            .catch((error)=>{console.error("Error updating profile", error)});
    }

    onEditUser() {
        this.props.history.push('/editprofile');
    }

    onEditGroup() {
        this.props.history.push('/switchgroup');
    }

    render() {

        var t = this.props.t;
        this.languageOptions[0].text = this.props.t('Auto-Detect Language'); //N.B switching out the entire languageOptions object causes buggy behaviour. Doing this for now

        var momentBirthDate = Boolean(this.props.userProfile.birthDate) ? moment(this.props.userProfile.birthDate, DateUtils.formatServer).utc() : null;
        var birthDateDisplayStr = (momentBirthDate && momentBirthDate.isValid()) ? momentBirthDate.format(DateUtils.formatDisplay) : '';
        return <Settings onEditUser={this.onEditUser}
                         onEditGroup={this.onEditGroup}
                         userProfile={this.props.userProfile}
                         onSignOut={this.onSignOut}
                         anonymous={this.state.anonymous}
                         weeklyReportEnabled={this.state.weeklyReportEnabled}
                         birthDate={birthDateDisplayStr}
                         languageOptions={this.languageOptions}
                         selectedLanguage={this.state.selectedLanguage || ''}
                         onChangeAnonymous={this.onChangeAnonymous}
                         onChangeWeeklyReportEnabled={this.onChangeWeeklyReportEnabled}
                         onChangeLanguage={this.onChangeLanguage}
                         onClickUnverified={this.onClickUnverified}
                         onClickChangePassword={this.onClickChangePassword}
                         onClickSendVerificationEmail={this.onClickSendVerificationEmail}
                         onCloseVerificationModal={this.onCloseVerificationModal}
                         onCloseChangePasswordModal={this.onCloseChangePasswordModal}
                         showVerificationModal={this.state.showVerificationModal}
                         showPasswordChangeModal={this.state.showPasswordChangeModal}
                         verificationEmailState={this.state.verificationEmailState}/>;
    }
}

function mapStateToProps(state, ownProps) {
    var userProfile = {firstName:'', lastName:'', team:{name:''}, company:{name:''}};

    if(state.user.userProfile) {
        userProfile = {...userProfile, ...state.user.userProfile};
    }
    if(userProfile.team==null) {
        userProfile.team = {name:'N/A'};
    }
    if(userProfile.company==null) {
        userProfile.company = {name:'N/A'};
    }
    return { userProfile: userProfile };
}

export default withRouter(connect(mapStateToProps)(translate('settings')(SettingsContainer)));



// WEBPACK FOOTER //
// ./src/modules/settings/SettingsContainer.js